export const generatePassword = (): string => {
    const lower = 'abcdefghijklmnopqrstuvwxyz';
    const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
    const symbols = '!@#$%^&*()_+-=';

    let pass = '';
    pass += lower[Math.floor(Math.random() * lower.length)];
    pass += upper[Math.floor(Math.random() * upper.length)];
    pass += numbers[Math.floor(Math.random() * numbers.length)];
    pass += symbols[Math.floor(Math.random() * symbols.length)];

    const allChars = lower + upper + numbers + symbols;
    const length = 14;
    for (let i = 4; i < length; i++) {
        pass += allChars[Math.floor(Math.random() * allChars.length)];
    }

    const shuffledPass = pass.split('').sort(() => 0.5 - Math.random()).join('');

    return shuffledPass;
};